import React from "react";

const Download = () =>{
        return(
            <>
            
   {/* <!-- download container start  --> */}
   <div class="container">
       <h2>Download Our Pdf</h2>
       <div class="row">
           <div class="col-sm-12 col-md-12 col-lg-9">
            <p class="">Free of Coust Programming Short Note useful for learning any basic programming of propertities about for language.
            </p>
           </div>
           
           <div class="col-lg-3 col-md-12 col-sm-12">
            <button class="btn   btn-dark">Download</button>
           </div>
           
       </div>
   </div>
   {/* <!-- download container end  --> */}

            </>
        );
};

export default Download;